





















import Vue from 'vue';
import SubstepNumber from '@/components/common/SubstepNumber.vue';

export default Vue.extend({
  name: 'InstructionsPage',
  components: {
    SubstepNumber,
  },
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/InstructionsPage.vue